import { render } from "./Results.vue?vue&type=template&id=2ab2be08"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"
script.render = render

export default script